import styled from 'styled-components';
import { CheckCircleOutlineUnchecked } from '@carvana/icons';

export const OutlineCircle = styled(CheckCircleOutlineUnchecked)`
  --size: ${props => props.size || '20px'};
  align-items: center;
  color: ${props => props.theme.carvana.blue.primary};
  display: flex;
  height: var(--size);
  width: var(--size);
`;

export default OutlineCircle;
